import React, { useReducer, ReactNode, useMemo, useRef } from 'react';
import { createContext } from '../selectableContext';
import InputActions from './actions';
import InputReducer from './reducer';

export const InputContext = createContext({});
export const initialInputState = {
  subject: {
    descriptionFieldShown: false,
    details: {
      title: '',
      description: '',
      secretAnswer: '',
      rewardLevel: 0,
      thumbnail: ''
    },
    hasSecretAnswer: false
  },
  content: {
    alreadyPosted: false,
    descriptionFieldShown: false,
    form: {
      url: '',
      isVideo: false,
      title: '',
      description: '',
      rewardLevel: 0
    },
    titleFieldShown: false,
    urlHelper: '',
    urlError: '',
    ytDetails: null
  },
  userInfo: {},
  userSearchText: '',
  playlistSearchText: ''
};

export function InputContextProvider({ children }: { children: ReactNode }) {
  const [inputState, inputDispatch] = useReducer(
    InputReducer,
    initialInputState
  );
  const latestInputStateRef = useRef<any>(initialInputState);
  latestInputStateRef.current = inputState;
  const memoizedActions = useMemo(
    () => InputActions(inputDispatch),
    [inputDispatch]
  );
  const getInputStateValue = useMemo(
    () => (key: string) => latestInputStateRef.current[key],
    []
  );
  const getInputState = useMemo(() => () => latestInputStateRef.current, []);
  const contextValue = useMemo(
    () => ({
      state: inputState,
      actions: memoizedActions,
      getInputStateValue,
      getInputState
    }),
    [getInputState, getInputStateValue, inputState, memoizedActions]
  );
  return (
    <InputContext.Provider value={contextValue}>{children}</InputContext.Provider>
  );
}
